import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorPage } from './ErrorPage';

interface ISomethingWentWrongProps {
  isContactForm?: boolean;
}

export const SomethingWentWrong: React.FC<ISomethingWentWrongProps> = ({ isContactForm = false }) => {
  const { t } = useTranslation();

  const title = t('something-went-wrong-title');
  const defaultBlurb = t('something-went-wrong-blurb');
  const formBlurb = t('something-went-wrong-form-blurb');

  return isContactForm ? (
    <ErrorPage title={title} blurb={formBlurb} />
  ) : (
    <ErrorPage title={title} blurb={defaultBlurb} hasImage />
  );
};
